import React from "react";
import PropTypes from "prop-types";
import { Oval } from "react-loader-spinner";

function Spinner({ centered, className, size = "medium" }) {
  // Определение размеров для разных контекстов
  const sizes = {
    small: 30,
    medium: 50,
    large: 80
  };
  
  // Получаем фактическое значение размера
  const sizeValue = sizes[size] || sizes.medium;
  
  return (
    <div
      className={`${
        centered
          ? "fixed inset-0 flex justify-center items-center z-50 bg-white bg-opacity-50"
          : "flex justify-center items-center h-full"
      } ${className || ""}`}
    >
      <Oval
        height={sizeValue}
        width={sizeValue}
        color="#8884d8" // Используем фиолетовый/индиго цвет из вашей панели статистики
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor="#e0e0e0"
        strokeWidth={2}
        strokeWidthSecondary={2}
      />
    </div>
  );
}

// Определяем propTypes для Spinner
Spinner.propTypes = {
  className: PropTypes.string,
  centered: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"])
};

export default Spinner;